import useFeaturePermissions from './useFeaturePermissions';
import { Permissions } from '@auth/permissions.ts';

/**
 * Get the permission of the entity functions
 * @param organizationId
 * @returns An object containing the write and read permissions
 */
export const useFunctionsPermissions = (organizationId: string) => {
  const { writePermission, readPermission } = useFeaturePermissions(organizationId, Permissions.FunctionsChange, Permissions.FunctionsRead);
  return { writePermission, readPermission };
};
